import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Tek sayfa uygulamasinda sayfa degistiginde tarayici kaydirma konumunu
// korur; uzun sozlesme sayfalarindan gecerken ortadan aciliyordu.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
